/**
 * Swiper
 * @url : https://swiperjs.com/api/
 */
// import Swiper JS
// core version + navigation, pagination, freemode & keyboard modules:
import Swiper from "swiper";
import {
  Navigation,
  Pagination,
  FreeMode,
  Keyboard,
  EffectFade,
} from "swiper/modules";

/**
 * Page Standard Swiper
 * Default + freemode
 */
// Default
const psSwiper = Array.from(
  document.getElementsByClassName("js-swiper-page-standard")
);

if (psSwiper.length) {
  for (const swiper of psSwiper) {
    // Swiper instance
    const psSwiperInstance = new Swiper(swiper, {
      modules: [Navigation, Pagination, Keyboard],
      slidesPerView: "auto",
      loop: false,
      speed: 700,

      navigation: {
        nextEl: swiper.querySelector(".swiper-button-next"),
        prevEl: swiper.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: swiper.querySelector(".swiper-pagination"),
        clickable: true,
      },
      keyboard: true,
      init: false,
    });

    // Init only if there is 2 or more slides
    const nbSlides = Array.from(swiper.getElementsByClassName("swiper-slide"));

    if (nbSlides.length > 1) {
      psSwiperInstance.init();
    }
  }
}

// Freemode
const swiperFreemode = Array.from(
  document.getElementsByClassName("js-swiper-freemode")
);
if (swiperFreemode.length) {
  for (const swiper of swiperFreemode) {
    // Swiper instance
    const swiperFreeModeInstance = new Swiper(swiper, {
      observer: true,
      modules: [Navigation, Pagination, FreeMode, Keyboard],
      slidesPerView: "auto",
      centeredSlides: false,
      grabCursor: true,
      freeMode: true,
      speed: 700,
      navigation: {
        nextEl: swiper.querySelector(".swiper-button-next"),
        prevEl: swiper.querySelector(".swiper-button-prev"),
      },
      keyboard: true,
      init: false,
    });

    // Init only if there is 2 or more slides
    const nbSlides = Array.from(swiper.getElementsByClassName("swiper-slide"));

    if (nbSlides.length > 1) {
      swiperFreeModeInstance.init();
    }
  }
}

// Freemode List of cards (activate depending on bloc width and screen size)
const swiperFreemodeList = Array.from(
  document.getElementsByClassName("js-swiper-freemode-list")
);
if (swiperFreemodeList.length) {
  for (const swiper of swiperFreemodeList) {
    // Swiper instance
    const swiperFreeModeListInstance = new Swiper(swiper, {
      modules: [Navigation, Pagination, FreeMode, Keyboard],
      slidesPerView: "auto",
      centeredSlides: false,
      watchOverflow: true,
      grabCursor: true,
      freeMode: {
        enabled: true,
        sticky: true,
      },
      spaceBetween: 0,
      speed: 700,
      navigation: {
        nextEl: swiper.querySelector(".swiper-button-next"),
        prevEl: swiper.querySelector(".swiper-button-prev"),
      },
      keyboard: true,
      init: false,
      on: {
        lock() {
          this.el?.classList.add("swiper-is-locked");
        },
        unlock() {
          this.el?.classList.remove("swiper-is-locked");
        },
      },
    });

    const nbSlides = Array.from(swiper.getElementsByClassName("swiper-slide"));
    if (nbSlides.length >= 1) {
      swiperFreeModeListInstance.init();
    }
  }
}

// 1 by 1
const swiperOnebyone = Array.from(
  document.getElementsByClassName("js-swiper-onebyone")
);
if (swiperOnebyone.length) {
  for (const swiper of swiperOnebyone) {
    // Swiper instance
    const swiperOnebyoneInstance = new Swiper(swiper, {
      modules: [Navigation, Keyboard, EffectFade, Pagination],
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      slidesPerView: 1,
      // loop:true,
      spaceBetween: 30,
      speed: 400,
      autoHeight: true,
      loop: true,
      navigation: {
        nextEl: swiper.querySelector(".swiper-button-next"),
        prevEl: swiper.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: swiper.querySelector(".swiper-pagination"),
        dynamicBullets: true,
      },
      keyboard: true,
      init: false,
    });

    // Init only if there is 2 or more slides
    const nbSlides = Array.from(swiper.getElementsByClassName("swiper-slide"));

    if (nbSlides.length > 1) {
      swiperOnebyoneInstance.init();
    }
  }
}
